import Button from "../../../../audi-ui-components/Button";
import {
  requestTypes,
} from "./CVOConstants";

const SubmittedBanner = ({ requestType }) => {
  return (
    <div className="aui-color-black aui-color-text-light py-7">
      <div className="content-wrapper py-5">
        {requestType === requestTypes.NO_LONGER_OWN && <div className="audi-forms__page py-medium-5">
          <p className="aui-headline-3 mb-5">Thank you, your updated details have been submitted.</p>
          <p className="mb-7">We'll contact you within 5 business days to confirm these changes.</p>
          <div className="cvo-thankyou-ctas">
            <Button variant="primary" theme="light" href="https://www.audi.com.au/en/models/" target="_blank" rel="nofollow noreferrer">
              Discover new models
            </Button>
          </div>
        </div>}
        {requestType === requestTypes.WRITTEN_OFF && <div className="audi-forms__page py-medium-5">
          <p className="aui-headline-3 mb-5">Thank you, your updated details have been submitted.</p>
          <p className="mb-7">We'll contact you within 5 business days to confirm these changes.</p>
          <div className="cvo-thankyou-ctas">
            <Button variant="primary" theme="light" href="https://www.audi.com.au/en/audi-new-car-search/" target="_blank" rel="nofollow noreferrer">
              Shop new vehicles
            </Button>
            <Button variant="secondary" theme="light" href="https://www.audi.com.au/en/audi-used-car-search/" target="_blank" rel="nofollow noreferrer">
              Shop pre-owned vehicles
            </Button>
          </div>
        </div>}
      </div>
    </div>
  );
};

export default SubmittedBanner;
